module.exports = __webpack_public_path__ + "f1215ab17ef740a8822826b0557df92a.png";